import React, { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CategoryTable from "./usercategory";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AddCategoryModalForm from "./AddCategoryModalForm";

const UserCategory = () => {
  const [showModal, setShowModal] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const handleSuccess = () => {
    setRefreshData((prev) => !prev);
    setShowModal(false);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  User Category
                </MDTypography>

                <MDButton
                  variant="contained"
                  color="light"
                  onClick={() => setShowModal(true)}
                >
                  + Add Category
                </MDButton>
              </MDBox>

              <MDBox pt={3}>
                <CategoryTable refreshTrigger={refreshData} />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Card style={{ padding: "2rem", width: "500px", maxHeight: "90vh", overflowY: "auto" }}>
            <AddCategoryModalForm onClose={() => setShowModal(false)} onSuccess={handleSuccess} />
          </Card>
        </div>
      )}
    </DashboardLayout>
  );
};

export default UserCategory;
